<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { AddProjectsDialogViewModel } from "@Quest/PortfolioScenarios/Components/AddProjectsDialog"

    // props
    const props = defineProps<{
        viewModel: AddProjectsDialogViewModel
    }>()

    // emits
    const emit = defineEmits<{
        (e: 'selection-confirmed', listId: string | null, statusId: number | null): void
    }>()

    // vm shortcut
    const vm = toRef(props, 'viewModel')

    // derived state
    const opened = computed(() => vm.value?.opened ?? false)

    const statuses = computed(() => vm.value.statuses)
    const lists = computed(() => vm.value.lists)

    // two-way bindings to ViewModel
    const selectedListId = computed<string | null>({
        get: () => vm.value.selectedListId,
        set: v => vm.value.selectedListId = v
    })

    const selectedStatusId = computed<number | null>({
        get: () => vm.value.selectedStatusId,
        set: v => vm.value.selectedStatusId = v
    })

    // methods
    function handleConfirm()
    {
        emit(
            'selection-confirmed',
            vm.value.selectedListId,
            vm.value.selectedStatusId
        )
    }

    function close()
    {
        vm.value.close()
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add projects to scenario</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <label>List:</label>
                            <select v-model="selectedListId" class="form-control">
                                <option :value="null">All</option>
                                <option v-for="l in lists" :key="l.Id" :value="l.Id">
                                    {{ l.Name }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Status:</label>
                            <select v-model="selectedStatusId" class="form-control">
                                <option :value="null">Any</option>
                                <option v-for="s in statuses" :key="s.Id" :value="s.Id">
                                    {{ s.Name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="handleConfirm" type="button" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
